const font = {
  size: 12,
  color: { argb: '000000' },
}

const style = {
  alignment: { horizontal: 'center', vertical: 'middle' },
  font,
  border: {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  }
}

export const HEADER_EXCEL_CUENTAS_OTROS_BANCOS = [
  { header: 'BANCO', key: 'banco', width: 35, style },
  { header: 'N° DE CUENTA ', key: 'numero_cuenta', width: 35, style },
]